import crud from "./crud";
import crud_service from "@/services/crud";

import { isNone } from "@/functions";

const path = "affectations";
// In-flight `latest` requests, keyed by "queryType:queryValue" (see getLatest).
const pendingLatest = {};
const struct = {
  date: null,
  unit_id: null,
  external_repair_id: null,
  internal_repair_id: null,
  stock_state_id: null,
  trash_state_id: null,
  producer_id: null,
};
const generic = crud(path, struct);

const state = {
  ...generic.state,
  kindId: null,
  latest: {},
};

const getters = {
  ...generic.getters,

  kindId: function (state) {
    return state.kindId;
  },
};

const mutations = {
  ...generic.mutations,

  kindId(state, _id) {
    state.kindId = _id;
  },

  editExternalRepair(state, item) {
    var index = state.items.findIndex(
      (obj) => obj.external_repair_id === item.pk,
    );
    if (index !== -1) {
      state.items[index].external_repair = item;
    }
  },

  editInternalRepair(state, item) {
    var index = state.items.findIndex(
      (obj) => obj.internal_repair_id === item.pk,
    );
    if (index !== -1) {
      state.items[index].internal_repair = item;
    }
  },

  setLatest(state, { queryKey, items }) {
    // Store items by their query key (e.g., 'stockage_id: 12' or 'producer_id: 6')
    state.latest[queryKey] = items;
    },
};

const actions = {
  ...generic.actions,

  kindId({ commit }, _id) {
    // temporary id var dispatched to external_repair_id, internal, producer_id
    commit("kindId", _id);
  },

  affect({ commit }, item) {
    if (isNone(item.pk)) {
      return new Promise((resolve) => {
        crud_service.post(`${path}`, item).then((item) => {
          commit("setItems", [item]);
          resolve(item);
        });
      });
    }
    return new Promise((resolve) => {
      crud_service.put(`${path}`, item).then((item) => {
        commit("setItems", [item]);
        resolve(item);
      });
    });
  },
  getInProduction({ commit }, { producer_id, no_qr_code, options }) {
    commit("setIsLoading", true);
    options["producer_id"] = producer_id;
    options["no_qr_code"] = no_qr_code;
    return new Promise((resolve) => {
      crud_service.fetch(`${path}/in_production`, options).then((items) => {
        commit("setItems", items.results);
        commit("setIsLoading", false);
        resolve(items);
      });
    });
    },
  getInStock({ commit }, { stockage_id, no_qr_code, options }) {
    commit("setIsLoading", true);
    options["stockage_id"] = stockage_id;
    options["no_qr_code"] = no_qr_code;

    return new Promise((resolve) => {
      crud_service.fetch(`${path}/latest`, options).then((items) => {
        commit("setItems", items.results);
        commit("setIsLoading", false);
        resolve(items);
      });
    });
    },

  getLatest({ commit }, { queryType, queryValue } = {}) {
    const filtered = !isNone(queryType);
    const queryKey = `${queryType}:${queryValue}`;
    // The report editor and the unit picker ask for the same stockage at the
    // same time: share the in-flight request instead of running it twice.
    if (filtered && pendingLatest[queryKey]) {
      return pendingLatest[queryKey];
    }

    commit("setIsLoading", true);
    // Filtered lists (by stockage or producer) feed the unit pickers and need
    // the whole list, not only the first page: walk every page of the compact
    // (light serializer) endpoint and concatenate the results.
    const query = filtered ? { [queryType]: queryValue, compact: true } : {};
    const fetchPage = (page) =>
      crud_service.fetch(`${path}/latest`, { ...query, page });

    const request = fetchPage(1)
      .then((first) => {
        const lastPage = first.last_page || 1;
        if (!filtered || lastPage <= 1) {
          return first;
        }
        const others = [];
        for (let page = 2; page <= lastPage; page++) {
          others.push(fetchPage(page));
        }
        return Promise.all(others).then((pages) => ({
          ...first,
          results: first.results.concat(...pages.map((p) => p.results)),
        }));
      })
      .then((items) => {
        commit("setLatest", { queryKey, items: items.results });
        commit("setItems", items.results);
        commit("setIsLoading", false);
        return items;
      })
      .catch((error) => {
        commit("setIsLoading", false);
        throw error;
      })
      .finally(() => {
        delete pendingLatest[queryKey];
      });

    if (filtered) {
      pendingLatest[queryKey] = request;
    }
    return request;
  },

  getOthers({ commit }, { stock_part_id, options }) {
    if (isNone(options)) {
      options = {};
    }
    if (!isNone(stock_part_id)) {
      options["stock_part_id"] = stock_part_id;
    }
    commit("setIsLoading", true);

    return new Promise((resolve, reject) => {
      crud_service
        .fetch(`${path}/latest`, options)
        .then((items) => {
          //commit("setItems", items.results);
          commit("setIsLoading", false);
          resolve(items);
        })
        .catch(() => {
          commit("setIsLoading", false);
          reject();
        });
    });
  },

  getUndoneExternalRepairs({ commit }, payload) {
    return new Promise((resolve, reject) => {
      crud_service
        .fetch(`${path}/external_repairs/undone_external`, payload)
        .then((response) => {
          const items = Array.isArray(response) ? response : [];
          commit("setItems", items);
          resolve(items);
        })
        .catch((error) => {
          console.error("Error fetching undone externals repairs:", error);
          commit("setItems", []);
          reject(error);
        });
    });
  },

  editExternalRepair({ commit }, external_repair) {
    return new Promise((resolve) => {
      crud_service.put(`external_repairs`, external_repair).then(() => {
        commit("editExternalRepair", external_repair);
        resolve();
      });
    });
  },

  getUndoneInternalRepairs({ commit }, payload) {
    return new Promise((resolve, reject) => {
      crud_service
        .fetch(`${path}/internal_repairs/undone_internal`, payload)
        .then((response) => {
          const items = Array.isArray(response) ? response : [];
          commit("setItems", items);
          resolve(items);
        })
        .catch((error) => {
          console.error("Error fetching undone internal repairs:", error);
          commit("setItems", []);
          reject(error);
        });
    });
  },
  

  editInternalRepair({ commit }, internal_repair) {
    return new Promise((resolve) => {
      crud_service.put(`internal_repairs`, internal_repair).then(() => {
        commit("editInternalRepair", internal_repair);
        resolve();
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
